import { WavesArrowRightIcon } from './WavesArrowRightIcon';

/**
 * author: Michael Irigoyen
 * id 69DDD960-779E-4BD9-9B96-B73ED9CAF55D
 * name waves-arrow-right
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/waves-arrow-right.svg
 * tags
 * - Nature 
 * - Weather 
 */
export const TideOutIcon = WavesArrowRightIcon;
export default TideOutIcon